import React from 'react'

export default function Footer() {
    return (
        <div className='footer w-100 py-1 mt-3 bg-white px-3 border-top'>
            <small>Copyright © 2022 Mindstores. All Rights Reserved.</small>
        </div>
    )
}
